export default __webpack_public_path__ + "static/media/ico-mysql-score-high.629e6764.svg";